import { const_var, params } from "../../../redux/reducers/reducer";
import { num } from "../../../redux/reducers/utils";

export function endStoragePriceCalculation(data, post_data, UpdatePriceRecord) {
	let utilityPrice = 0;
	const sideValue = (params.p_l_w !== "Close") + (params.p_r_w !== "Close");
	const utilityPosition = parseFloat((post_data["building"].utility_position = params.endStoragePositionZ));
	const endValue = utilityPosition !== 0 && utilityPosition + parseFloat(params.p_u_t) !== params.p_d ? 2 : 1;
	const isUpdatedPrice = UpdatePriceRecord === true && const_var.UpdatedPriceData.utility_price_changed !== true;
	const isVertical = params.p_v_w === true;
	const endData = data?.end[0];
	const sideData = data.utility_side[0];
	if (isUpdatedPrice) {
		utilityPrice = const_var.UpdatedPriceData.utility_price;
	} else if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to") && data.utility_slope_height.length > 0) {
		const slopeData = data.utility_slope_height[0];
		const higherSide = params.p_r_w !== "Close" ? (isVertical ? sideData.vertical_side_cost + sideData.side_close_cost : sideData.side_close_cost) : 0;
		const lowerSide = params.p_l_w !== "Close" ? (isVertical ? slopeData.vertical_side_cost + slopeData.side_close_cost : slopeData.side_close_cost) : 0;
		utilityPrice = isVertical ? endData.vertical_ends_cost * endValue + higherSide + lowerSide + endData.end_close_cost * endValue : higherSide + lowerSide + endData.end_close_cost * endValue;
	} else {
		utilityPrice = isVertical
			? sideData.vertical_side_cost * sideValue + endData.vertical_ends_cost * endValue + sideData.side_close_cost * sideValue + endData.end_close_cost * endValue
			: sideData.side_close_cost * sideValue + endData.end_close_cost * endValue;
	}
	utilityPrice = num(utilityPrice);
	const distanceOnCenter = const_var.DistanceArr[params.p_b_t][params.p_r_s] ?? 5;
	const b_u_D_p_a = distanceOnCenter === 5 ? const_var.b_u_D_p_a5 : distanceOnCenter === 4 ? const_var.b_u_D_p_a4 : Object.values(const_var.b_u_D_p_a);

	post_data["building"].utility_price = utilityPrice;
	post_data["building"].utility_length = params.p_u_t;
	post_data["building"].has_utility = true;
	post_data["building"].utility_name = "back";
	post_data["building"].utility_vertical = !!params.p_v_w;
	post_data["building"].utility_on_centers = distanceOnCenter;
	post_data["building"].utility_length_list = b_u_D_p_a;

	return utilityPrice;
}

export function leftRightStoragePriceCalculation(data, post_data, UpdatePriceRecord) {
	let utilityPrice = 0;
	const endValue = (params.p_f_w != "Close" ? 1 : 0) + (params.p_b_w != "Close" ? 1 : 0);
	const sideValue = 1;

	const isMaxHeight = params.p_h >= const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value;
	const isNotLeanTo = !const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to");
	const panelCost = params.p_v_w ? data.panel[0].vertical_panel_cost : data.panel[0].cost;
	const exactPriceAdd = isMaxHeight && isNotLeanTo ? panelCost * sideValue : 0;

	const hasSideCombo = data.side_combo_v3.length > 0;
	const hasEndCombo = data.end_combo_v3.length > 0;

	const sideCloseCostOnZeroPrice = hasSideCombo && data.side_combo_v3[0].side_close_cost === 0 ? data.side[0].side_close_cost : 0;
	let endCloseCostOnZeroPrice = 0;
	if (hasEndCombo && data.end_combo_v3[0].end_close_cost === 0) {
		endCloseCostOnZeroPrice = endValue * data.end[0].end_close_cost;
		if (Number(params.p_r_p) > 3 && data.gable_end[0]?.certified) {
			endCloseCostOnZeroPrice += data.gable_end[0].certified;
		}
	}
	const newSideWallPrice = params.singleSlope && params.cB_addStorage_check_left && data.side_slope_height?.length > 0 ? data.side_slope_height : data.side;
	const endComboBase = hasEndCombo ? data.end_combo_v3[0].end_close_cost : 0;
	const endComboVertical = hasEndCombo ? data.end_combo_v3[0].vertical_ends_cost : 0;
	const endCost = params.p_v_w ? (endComboVertical + endComboBase) * endValue : endComboBase * endValue;

	const sideComboSideClose = hasSideCombo ? data.side_combo_v3[0].side_close_cost : 0;
	const sideComboVerticalSide = hasSideCombo ? data.side_combo_v3[0].vertical_side_cost : 0;

	const isUpdatedPrice = UpdatePriceRecord === true && const_var.UpdatedPriceData.utility_price_changed !== true;
	utilityPrice = isUpdatedPrice
		? const_var.UpdatedPriceData.utility_price
		: params.p_v_w
			? num(sideComboVerticalSide + sideComboSideClose + endCost)
			: num(sideComboSideClose + sideCloseCostOnZeroPrice + endCost + endCloseCostOnZeroPrice);

	post_data["building"].utility_price = utilityPrice;
	post_data["building"].utility_length = params.cB_addStorage_check_left ? params.cB_addStorage_left : params.cB_addStorage_right;
	post_data["building"].has_utility = true;
	post_data["building"].utility_name = params.cB_addStorage_check_left ? "left" : "right";
	post_data["building"].utility_vertical = !!params.p_v_w;
	post_data["building"].utility_on_centers = const_var.DistanceArr[params.p_b_t][params.p_r_s] ?? 5;

	const onCenters = post_data["building"].utility_on_centers;
	const b_u_D_p_a = onCenters === 5 ? const_var.b_u_D_p_a5 : onCenters === 4 ? const_var.b_u_D_p_a4 : const_var.b_u_D_p_a && Object.values(const_var.b_u_D_p_a);

	post_data["building"].utility_length_list = b_u_D_p_a;
	console.log("utilityPrice", utilityPrice);
	return utilityPrice;
}
export const calcWallCostUtility = (storageType, calcfor, paramsData, wall, costObj, storageValue, leanToLength, leanCount, lowerHeight = 0, isCenterBuidling = false, wallname = "") => {
	let Price = 0;
	// center buidling back storage
	if (storageType == "backStorage") {
		let length = parseFloat(paramsData.p_d);

		let exactHeight = lowerHeight != 0 ? lowerHeight : paramsData.p_h;

		if (isCenterBuidling == true && wall != "Close" && wallname == "rightwall" && paramsData.add_storage_check_right == true && parseFloat(paramsData.add_storage_right) > parseInt(paramsData.p_u_t)) {
			length = parseFloat(paramsData.p_d) - parseFloat(paramsData.add_storage_right);
			Price = parseFloat(Price) + parseFloat(paramsData.add_storage_right * exactHeight * costObj.cost);
		} else if (isCenterBuidling == true && wall != "Close" && wallname == "leftwall" && paramsData.add_storage_check == true && parseFloat(paramsData.add_storage) > parseInt(paramsData.p_u_t)) {
			length = parseFloat(paramsData.p_d) - parseFloat(paramsData.add_storage);
			Price = parseFloat(Price) + parseFloat(paramsData.add_storage * exactHeight * costObj.cost);
		} else {
			length = wall != "Close" ? parseInt(paramsData.p_d) - parseInt(paramsData.p_u_t) : parseFloat(paramsData.p_d); //remaining wall length
			if (calcfor == "side" && wall != "Close") {
				Price = parseFloat(Price) + parseFloat(paramsData.p_u_t * exactHeight * costObj.cost);
			}
		}

		if (calcfor == "side" && wall != "Open") {
			if (wall == "One_Fourth_Close") {
				Price = parseFloat(Price) + parseFloat(length * ((1 / 4) * parseInt(exactHeight)) * costObj.cost);
			} else if (wall == "Half_Close") {
				Price = parseFloat(Price) + parseFloat(length * ((1 / 2) * parseInt(exactHeight)) * costObj.cost);
			} else if (wall == "Three_Fourth_Close") {
				Price = parseFloat(Price) + parseFloat(length * ((3 / 4) * parseInt(exactHeight)) * costObj.cost);
			} else if (wall != "Close") {
				Price = parseFloat(Price) + parseFloat(length * (parseInt(wall) * 3) * costObj.cost);
			} else {
				Price = parseFloat(Price) + parseFloat(length * exactHeight * costObj.cost);
			}
		}
		if (calcfor == "end" && wall != "Open") {
			if (wall == "Extended Gable") {
				Price = parseFloat(Price) + parseFloat(6 * paramsData.p_w * costObj.cost);
			} else if (wall == "Gable") {
				Price = parseFloat(Price) + parseFloat(3 * paramsData.p_w * costObj.cost);
			} else if (wall == "One_Fourth_Close") {
				Price = parseFloat(Price) + parseFloat((1 / 4) * parseInt(paramsData.p_h) * paramsData.p_w * costObj.cost);
			} else if (wall == "Half_Close") {
				Price = parseFloat(Price) + parseFloat((1 / 2) * parseInt(paramsData.p_h) * paramsData.p_w * costObj.cost);
			} else if (wall == "Three_Fourth_Close") {
				Price = parseFloat(Price) + parseFloat((3 / 4) * parseInt(paramsData.p_h) * paramsData.p_w * costObj.cost);
			} else {
				if (params.p_b_t == 27 || params.p_b_t == 33) {
					Price = parseFloat(Price) + parseFloat(parseInt(paramsData.p_h) * paramsData.p_w * costObj.cost);
				} else {
					if (params.m_s_n == 93) {
						Price = parseFloat(Price) + parseFloat((parseInt(paramsData.p_h) + 1.5) * paramsData.p_w * costObj.cost);
					} else {
						Price = parseFloat(Price) + parseFloat((parseInt(paramsData.p_h) + 1) * paramsData.p_w * costObj.cost);
					}
				}
			}
		}
	}
	if (storageType == "sideStorage") {
		if (calcfor == "end") {
			let width = wall == "Open" ? storageValue : wall != "Close" ? parseInt(paramsData.p_w) - parseInt(storageValue) : paramsData.p_w;

			if (wall != "Open") {
				if (wall != "Close") {
					if (params.p_b_t == 27 || params.p_b_t == 33) {
						Price = parseFloat(Price) + parseFloat(paramsData.p_h * storageValue * costObj.cost);
					} else {
						if (params.m_s_n == 93) {
							Price = parseFloat(Price) + parseFloat((paramsData.p_h + 1.5) * storageValue * costObj.cost);
						} else {
							Price = parseFloat(Price) + parseFloat((paramsData.p_h + 1) * storageValue * costObj.cost);
						}
					}
				}
				if (wall == "Extended Gable") {
					Price = parseFloat(Price) + parseFloat(6 * width * costObj.cost);
				} else if (wall == "Gable") {
					Price = parseFloat(Price) + parseFloat(3 * width * costObj.cost);
				} else if (wall == "One_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat((1 / 4) * parseInt(paramsData.p_h) * width * costObj.cost);
				} else if (wall == "Half_Close") {
					Price = parseFloat(Price) + parseFloat((1 / 2) * parseInt(paramsData.p_h) * width * costObj.cost);
				} else if (wall == "Three_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat((3 / 4) * parseInt(paramsData.p_h) * width * costObj.cost);
				} else {
					if (params.p_b_t == 27 || params.p_b_t == 33) {
						Price = parseFloat(Price) + parseFloat(parseInt(paramsData.p_h) * width * costObj.cost);
					} else {
						if (params.m_s_n == 93) {
							Price = parseFloat(Price) + parseFloat((parseInt(paramsData.p_h) + 1.5) * width * costObj.cost);
						} else {
							Price = parseFloat(Price) + parseFloat((parseInt(paramsData.p_h) + 1) * width * costObj.cost);
						}
					}
				}
			}
			if (wall == "Open") {
				if (params.p_b_t == 27 || params.p_b_t == 33) {
					Price = parseFloat(Price) + parseFloat(paramsData.p_h * storageValue * costObj.cost);
				} else {
					if (params.m_s_n == 93) {
						Price = parseFloat(Price) + parseFloat((paramsData.p_h + 1.5) * storageValue * costObj.cost);
					} else {
						Price = parseFloat(Price) + parseFloat((paramsData.p_h + 1) * storageValue * costObj.cost);
					}
				}
			}
		}
		if (calcfor == "side" && wall != "Open") {
			let exactHeight = lowerHeight != 0 ? lowerHeight : paramsData.p_h;
			if (wall == "One_Fourth_Close") {
				Price = parseFloat(Price) + parseFloat(paramsData.p_d * ((1 / 4) * parseInt(exactHeight)) * costObj.cost);
			} else if (wall == "Half_Close") {
				Price = parseFloat(Price) + parseFloat(paramsData.p_d * ((1 / 2) * parseInt(exactHeight)) * costObj.cost);
			} else if (wall == "Three_Fourth_Close") {
				Price = parseFloat(Price) + parseFloat(paramsData.p_d * ((3 / 4) * parseInt(exactHeight)) * costObj.cost);
			} else if (wall != "Close") {
				Price = parseFloat(Price) + parseFloat(paramsData.p_d * (parseInt(wall) * 3) * costObj.cost);
			} else {
				Price = parseFloat(Price) + parseFloat(paramsData.p_d * exactHeight * costObj.cost);
			}
		}
	}
	if (storageType == "frontLeanStorage") {
		if (calcfor == "side") {
			if (wall == "Open") {
				Price = parseFloat(Price) + parseFloat(paramsData.add_storage_front * paramsData.leanF_p_h * costObj.cost * leanCount);
			} else {
				let actualLength = leanToLength;
				if (const_var.wallsData["center"].p_f_w == "Open") {
					Price = parseFloat(Price) + parseFloat(paramsData.add_storage_front * paramsData.leanF_p_h * costObj.cost);
				}
				if (paramsData.add_storage_check_front == true && wall != "Close" && wall != "Open") {
					Price = parseFloat(Price) + parseFloat(paramsData.add_storage_front * paramsData.leanF_p_h * costObj.cost);
					actualLength = parseFloat(leanToLength) - parseFloat(paramsData.add_storage_front);
				}
				if (wall == "One_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((1 / 4) * parseInt(paramsData.leanF_p_h)) * costObj.cost);
				} else if (wall == "Half_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((1 / 2) * parseInt(paramsData.leanF_p_h)) * costObj.cost);
				} else if (wall == "Three_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((3 / 4) * parseInt(paramsData.leanF_p_h)) * costObj.cost);
				} else if (wall != "Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * (parseInt(wall) * 3) * costObj.cost);
				} else {
					Price = parseFloat(Price) + parseFloat(actualLength * paramsData.leanF_p_h * costObj.cost);
				}
			}
		}
	}
	if (storageType == "backLeanStorage") {
		if (calcfor == "side") {
			if (wall == "Open") {
				Price = parseFloat(Price) + parseFloat(paramsData.add_storage_back * paramsData.leanB_p_h * costObj.cost * leanCount);
			} else {
				let actualLength = leanToLength;
				if (const_var.wallsData["center"].p_b_w == "Open" && paramsData.p_u_c != true) {
					Price = parseFloat(Price) + parseFloat(paramsData.add_storage_back * paramsData.leanB_p_h * costObj.cost);
				}
				if (paramsData.add_storage_check_back == true && wall != "Close" && wall != "Open") {
					Price = parseFloat(Price) + parseFloat(paramsData.add_storage_back * paramsData.leanB_p_h * costObj.cost);
					actualLength = parseFloat(leanToLength) - parseFloat(paramsData.add_storage_back);
				}
				if (wall == "One_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((1 / 4) * parseInt(paramsData.leanB_p_h)) * costObj.cost);
				} else if (wall == "Half_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((1 / 2) * parseInt(paramsData.leanB_p_h)) * costObj.cost);
				} else if (wall == "Three_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((3 / 4) * parseInt(paramsData.leanB_p_h)) * costObj.cost);
				} else if (wall != "Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * (parseInt(wall) * 3) * costObj.cost);
				} else {
					Price = parseFloat(Price) + parseFloat(actualLength * paramsData.leanB_p_h * costObj.cost);
				}
			}
		}
	}
	if (storageType == "leftLeanStorage") {
		if (calcfor == "side") {
			if (wall == "Open") {
				Price = parseFloat(Price) + parseFloat(paramsData.add_storage * paramsData.lean_p_h * costObj.cost * parseInt(leanCount));
			} else {
				let actualLength = leanToLength;
				if (const_var.wallsData["center"].p_l_w == "Open" && paramsData.cB_addStorage_check_left != true) {
					Price = parseFloat(Price) + parseFloat(paramsData.add_storage * paramsData.lean_p_h * costObj.cost);
				}
				if (paramsData.add_storage_check == true && wall != "Close" && wall != "Open") {
					Price = parseFloat(Price) + parseFloat(paramsData.add_storage * paramsData.lean_p_h * costObj.cost);
					actualLength = parseFloat(leanToLength) - parseFloat(paramsData.add_storage);
				}
				if (wall == "One_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((1 / 4) * parseInt(paramsData.lean_p_h)) * costObj.cost);
				} else if (wall == "Half_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((1 / 2) * parseInt(paramsData.lean_p_h)) * costObj.cost);
				} else if (wall == "Three_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((3 / 4) * parseInt(paramsData.lean_p_h)) * costObj.cost);
				} else if (wall != "Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * (parseInt(wall) * 3) * costObj.cost);
				} else {
					Price = parseFloat(Price) + parseFloat(actualLength * paramsData.lean_p_h * costObj.cost);
				}
			}
		}
	}
	if (storageType == "rightLeanStorage") {
		if (calcfor == "side") {
			if (wall == "Open") {
				Price = parseFloat(Price) + parseFloat(paramsData.add_storage_right * paramsData.leanR_p_h * costObj.cost * leanCount);
			} else {
				let actualLength = leanToLength;
				if (const_var.wallsData["center"].p_r_w == "Open" && paramsData.cB_addStorage_check_right != true) {
					Price = parseFloat(Price) + parseFloat(paramsData.add_storage_right * paramsData.leanR_p_h * costObj.cost);
				}
				if (paramsData.add_storage_check_right == true && wall != "Close" && wall != "Open") {
					Price = parseFloat(Price) + parseFloat(paramsData.add_storage_right * paramsData.lean_p_h * costObj.cost);
					actualLength = parseFloat(leanToLength) - parseFloat(paramsData.add_storage_right);
				}
				if (wall == "One_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((1 / 4) * parseInt(paramsData.leanR_p_h)) * costObj.cost);
				} else if (wall == "Half_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((1 / 2) * parseInt(paramsData.leanR_p_h)) * costObj.cost);
				} else if (wall == "Three_Fourth_Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * ((3 / 4) * parseInt(paramsData.leanR_p_h)) * costObj.cost);
				} else if (wall != "Close") {
					Price = parseFloat(Price) + parseFloat(actualLength * (parseInt(wall) * 3) * costObj.cost);
				} else {
					Price = parseFloat(Price) + parseFloat(actualLength * paramsData.leanR_p_h * costObj.cost);
				}
			}
		}
	}
	return Price;
};
